import React, { useState, useEffect, useRef } from "react";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import axios from "axios";

export default function SmsManage() {
    const toast = useRef(null);

    const [smsList, setSmsList] = useState([]);
    const [visible, setVisible] = useState(false);
    const [editingSms, setEditingSms] = useState(null);
    const [globalFilter, setGlobalFilter] = useState("");

    const [formData, setFormData] = useState({
        id: null,
        message_type: "",
        entity_id: "",
        api_key: "",
        template_id: "",
        user_id: "",
        sender_id: "",
        branch_title: "",
        location: "",
        mobile_number: "",
        owner_number: "",
        email_id: "",
        administrative_email: "",
        short_url: "",
        status: "Active"
    });

    const [errors, setErrors] = useState({});

    const fetchSmsList = async () => {
        try {
            const res = await axios.get('https://treatway.co.in/Counter-Backend/api/server_masters/list/sms_manage');
            setSmsList(res.data || []);
        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => {
        fetchSmsList();
    }, []);

    const onInputChange = (e, name) => {
        const value = e.target.value;
        setFormData({ ...formData, [name]: value });

        let newErrors = { ...errors };

        if (name === "email_id" || name === "administrative_email") {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (emailRegex.test(value)) {
                delete newErrors[name];
            }
        } else if (name === "mobile_number" || name === "owner_number") {
            const mobileRegex = /^[0-9]{10}$/;
            if (mobileRegex.test(value)) {
                delete newErrors[name];
            }
        } else if (name === "short_url") {
            const urlRegex = /^(https?:\/\/[^\s]+)$/;
            if (urlRegex.test(value)) {
                delete newErrors[name];
            }
        } else {
            if (value.trim() !== "") {
                delete newErrors[name];
            }
        }

        setErrors(newErrors);
    };


    // Validation
    const validateForm = () => {
        let newErrors = {};
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const mobileRegex = /^[0-9]{10}$/;
        const urlRegex = /^(https?:\/\/[^\s]+)$/;

        // Define only required fields
        const requiredFields = [
            "message_type",
            "entity_id",
            "api_key",
            "template_id",
            "user_id",
            "sender_id",
            "mobile_number",
            "status"
        ];

        requiredFields.forEach((key) => {
            if (!formData[key] || !formData[key].toString().trim()) {
                newErrors[key] = "This field is required";
            }
        });

        // Specific validations
    /*    if (formData.mobile_number && !mobileRegex.test(formData.mobile_number)) {
            newErrors.mobile_number = "Invalid mobile number (10 digits required)";
        }

        if (formData.owner_number && !mobileRegex.test(formData.owner_number)) {
            newErrors.owner_number = "Invalid owner mobile number (10 digits required)";
        }

        if (formData.email_id && !emailRegex.test(formData.email_id)) {
            newErrors.email_id = "Invalid email format";
        }*/

        if (formData.administrative_email && formData.administrative_email.trim() !== "" && !emailRegex.test(formData.administrative_email)) {
            newErrors.administrative_email = "Invalid administrative email format";
        }

        if (formData.short_url && formData.short_url.trim() !== "" && !urlRegex.test(formData.short_url)) {
            newErrors.short_url = "Invalid URL format";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const saveSms = async () => {
        if (!validateForm()) {
            toast.current.show({ severity: "error", summary: "Validation Error", detail: "Please fix errors before saving" });
            return;
        }

        try {
            const url = editingSms ? 'https://treatway.co.in/Counter-Backend/api/server_masters/save/sms_manage' : 'https://treatway.co.in/Counter-Backend/api/server_masters/save/sms_manage';

           // await axios.post(url, formData);
           await axios.post(url, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });

            toast.current.show({
                severity: "success",
                summary: "Success",
                detail: editingSms ? "SMS Config Updated" : "SMS Config Added"
            });

            setVisible(false);
            setEditingSms(null);
            setFormData({
                id: null,
                message_type: "",
                entity_id: "",
                api_key: "",
                template_id: "",
                user_id: "",
                sender_id: "",
                branch_title: "",
                location: "",
                mobile_number: "",
                owner_number: "",
                email_id: "",
                administrative_email: "",
                short_url: "",
                status: "Active"
            });
            fetchSmsList();
        } catch (err) {
            console.error(err);
            toast.current.show({ severity: "error", summary: "Error", detail: "Something went wrong" });
        }
    };

    const editSms = async (rowData) => {
        try {
            const res = await axios.get(`https://treatway.co.in/Counter-Backend/api/server_masters/get_sms_by_id/${rowData.message_type_id}`);

            const data = res.data;

            setEditingSms(true);
            setFormData({
                id: data.message_type_id,
                message_type: data.message_type,
                entity_id: data.enitity_id,
                api_key: data.api_key,
                template_id: data.template_id,
                user_id: data.user_id,
                sender_id: data.sender_id,
                branch_title: data.branch_title,
                location: data.location,
                mobile_number: data.mobile_no,
                owner_number: data.owner_num,
                email_id: data.email_id,
                administrative_email: data.adminstrative_email,
                short_url: data.shorts_url,
                status: data.status
            });

            setVisible(true);
        } catch (err) {
            console.error(err);
            toast.current.show({ severity: "error", summary: "Error", detail: "Failed to load SMS details" });
        }
    };

    const dialogFooter = (
        <div>
            <Button label="Cancel" icon="pi pi-times" className="p-button-text" onClick={() => setVisible(false)} />
            <Button label="Save" icon="pi pi-check" onClick={saveSms} />
        </div>
    );

    const statusOptions = [
        { label: "Active", value: "Active" },
        { label: "InActive", value: "InActive" }
    ];

    return (
        <>
            <Toast ref={toast} />
            <h2 className="text-xl font-bold mb-4">SMS Management</h2>
            <div className="card">
                <div className="flex flex-wrap justify-between items-center mb-4 gap-3">
                    <Button
                        label="Add SMS Config"
                        icon="pi pi-plus"
                        onClick={() => {
                            setVisible(true);
                            setEditingSms(null);
                            setFormData({
                                id: null,
                                message_type: "",
                                entity_id: "",
                                api_key: "",
                                template_id: "",
                                user_id: "",
                                sender_id: "",
                                branch_title: "",
                                location: "",
                                mobile_number: "",
                                owner_number: "",
                                email_id: "",
                                administrative_email: "",
                                short_url: "",
                                status: "Active"
                            });
                        }}
                    />
                    <span className="p-input-icon-left ml-auto w-full sm:w-auto min-w-[250px]">
                        <i className="pi pi-search"></i>
                        <InputText
                            value={globalFilter}
                            onChange={(e) => setGlobalFilter(e.target.value)}
                            placeholder="Search..."
                            className="p-inputtext-sm w-full"
                        />
                    </span>
                </div>

                <DataTable value={smsList}
                    showGridlines
                    paginator
                    rows={25}
                    rowsPerPageOptions={[10, 25, 50]}
                    paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                    currentPageReportTemplate="{first} to {last} of {totalRecords}"
                    tableStyle={{ minWidth: '60rem' }}
                    className="p-datatable-sm relative"
                    emptyMessage="No SMS Configs found."
                    globalFilter={globalFilter}
                >
                    <Column field="message_type" header="Message Type" />
                    <Column field="status" header="Status" />
                    <Column
                        header="Actions"
                        body={(rowData) => (
                            <Button
                                icon="pi pi-pencil"
                                className="p-button-rounded p-button-warning mr-2"
                                onClick={() => editSms(rowData)}
                            />
                        )}
                    />
                </DataTable>

                <Dialog
                    header={editingSms ? "Edit SMS Config" : "Add SMS Config"}
                    visible={visible}
                    style={{ width: "800px" }}
                    footer={dialogFooter}
                    onHide={() => setVisible(false)}
                >
                    <div className="formgrid grid">
                        {/* Message Details */}
                        <div className="field col-12 md:col-6">
                            <label htmlFor="message_type">Message Type</label>
                            <InputText
                                id="message_type"
                                value={formData.message_type}
                                onChange={(e) => onInputChange(e, "message_type")}
                                className="w-full"
                            />
                            {errors.message_type && <small className="p-error">{errors.message_type}</small>}
                        </div>

                        <div className="field col-12 md:col-6">
                            <label htmlFor="status">Status</label>
                            <Dropdown
                                id="status"
                                value={formData.status}
                                options={statusOptions}
                                onChange={(e) => setFormData({ ...formData, status: e.value })}
                                className="w-full"
                            />
                            {errors.status && <small className="p-error">{errors.status}</small>}
                        </div>

                        {/* API / IDs */}
                        {["entity_id", "api_key", "template_id", "user_id", "sender_id"].map((key) => (
                            <div className="field col-12 md:col-6" key={key}>
                                <label htmlFor={key}>{key.replace(/_/g, " ").toUpperCase()}</label>
                                <InputText
                                    id={key}
                                    value={formData[key]}
                                    onChange={(e) => onInputChange(e, key)}
                                    className="w-full"
                                />
                                {errors[key] && <small className="p-error">{errors[key]}</small>}
                            </div>
                        ))}

                        {/* Branch & Location */}
                        {["branch_title", "location"].map((key) => (
                            <div className="field col-12 md:col-6" key={key}>
                                <label htmlFor={key}>{key.replace(/_/g, " ").toUpperCase()}</label>
                                <InputText
                                    id={key}
                                    value={formData[key]}
                                    onChange={(e) => onInputChange(e, key)}
                                    className="w-full"
                                />
                                {errors[key] && <small className="p-error">{errors[key]}</small>}
                            </div>
                        ))}

                        {/* Contacts */}
                        {["mobile_number", "owner_number", "email_id", "administrative_email"].map((key) => (
                            <div className="field col-12 md:col-6" key={key}>
                                <label htmlFor={key}>{key.replace(/_/g, " ").toUpperCase()}</label>
                                <InputText
                                    id={key}
                                    value={formData[key]}
                                    onChange={(e) => onInputChange(e, key)}
                                    className="w-full"
                                />
                                {errors[key] && <small className="p-error">{errors[key]}</small>}
                            </div>
                        ))}

                        {/* Short URL */}
                        <div className="field col-12 md:col-6">
                            <label htmlFor="short_url">Short URL</label>
                            <InputText
                                id="short_url"
                                value={formData.short_url}
                                onChange={(e) => onInputChange(e, "short_url")}
                                className="w-full"
                            />
                            {errors.short_url && <small className="p-error">{errors.short_url}</small>}
                        </div>
                    </div>
                </Dialog>


            </div>
        </>
    );
}
